import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../../../shared/components/crud/abstract-crud.service';
import { API_PATH } from 'src/environments/environment';
import { RELATIVE_URL } from './crud-config';
import { ICustomer } from 'src/app/domain/customer/ICustomer';

@Injectable()
export class TenantService extends AbstractCrudService {
  override title = 'Tenant';
  override pluralTitle = 'Tenants';

  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  createByCustomer(customerId: string): Observable<Object> {
    return this.httpClient.post<Object>(
      `${API_PATH}${this.relativeUrl}/create-by-customer/${customerId}`,
      {}
    );
  }

  public resetPasswordByCustomer(customerId: string) {
    return this.httpClient.put(
      `${API_PATH}${this.relativeUrl}/reset-password-by-customer/${customerId}`,
      {}
    );
  }
}
